var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteBucket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_115354",
    "data-name": "Group 115354",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.868,
    height: 21.999,
    viewBox: "0 0 17.868 21.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_107347",
    "data-name": "Path 107347",
    d: "M222.914,154.7a.515.515,0,0,0-.515.515v9.737a.515.515,0,0,0,1.03,0v-9.737A.515.515,0,0,0,222.914,154.7Zm0,0",
    transform: "translate(-210.94 -146.732)",
    fill: "red"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_107348",
    "data-name": "Path 107348",
    d: "M104.914,154.7a.515.515,0,0,0-.515.515v9.737a.515.515,0,0,0,1.03,0v-9.737A.515.515,0,0,0,104.914,154.7Zm0,0",
    transform: "translate(-99.02 -146.732)",
    fill: "red"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_107349",
    "data-name": "Path 107349",
    d: "M1.46,6.548V19.242a2.842,2.842,0,0,0,.756,1.96,2.537,2.537,0,0,0,1.841.8h9.748a2.537,2.537,0,0,0,1.841-.8,2.842,2.842,0,0,0,.756-1.96V6.548a1.968,1.968,0,0,0-.5-3.87H13.259V2.034A2.024,2.024,0,0,0,11.219,0H6.643A2.024,2.024,0,0,0,4.6,2.034v.644H1.965a1.968,1.968,0,0,0-.5,3.87Zm12.345,14.42H4.057a1.632,1.632,0,0,1-1.566-1.726V6.593H15.371V19.242A1.632,1.632,0,0,1,13.805,20.968ZM5.634,2.034a.993.993,0,0,1,1.01-1h4.575a.993.993,0,0,1,1.01,1v.644H5.634ZM1.965,3.708H15.9a.927.927,0,1,1,0,1.855H1.965a.927.927,0,1,1,0-1.855Zm0,0",
    transform: "translate(0.003 0.001)",
    fill: "red"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_107350",
    "data-name": "Path 107350",
    d: "M163.914,154.7a.515.515,0,0,0-.515.515v9.737a.515.515,0,0,0,1.03,0v-9.737A.515.515,0,0,0,163.914,154.7Zm0,0",
    transform: "translate(-154.979 -146.732)",
    fill: "red"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBucket);
export default __webpack_public_path__ + "static/media/delete_bucket.3f42696bb6d531c64a89dfd3c42b80c9.svg";
export { ForwardRef as ReactComponent };